import {Direction} from './types';

// These default sizes correspond to the sidebar
// When resizing, allow the sidebar to "snap" to it's default width when falling within +/- this value
export const PANEL_RESIZE_SNAP_WINDOW = 12;
export const PANEL_MIN_WIDTH = 330;
export const PANEL_DEFAULT_WIDTH = 330;
export const PANEL_COLLAPSED_WIDTH = 60;
export const PANEL_MAX_WIDTH = 700;

export const SIDEBAR_DEFAULT_RATIO = 0.22;
export const DATA_TABLE_DEFAULT_RATIO = 0.5;

export const DATA_TABLE_MIN_HEIGHT = 220;
// min height of the chart area (above the data table panel) including padding
export const CHART_CONTAINER_MIN_HEIGHT = 276;
export const CHART_AND_TABLE_THRESHOLD_HEIGHT = 650;

// defines which suggested width is presented to the user by default
export const PANEL_MAX_AUTO_WIDTH = 560;

export const DEFAULT_PERSISTED_STATE = {
  isCollapsed: false,
  size: null,
};

export const KEYDOWN_EVENTS = {
  Meta: `Meta`,
  Ctrl: `Ctrl`,
  Backslash: `Backslash`,
  Digit1: `Digit1`,
};

export const KEYDOWN_EVENTS_CHARACTER = {
  Backslash: `\\`,
  Digit1: `1`,
};

export const VERTICAL_DIRECTIONS = new Set<Direction>([Direction.Top, Direction.Bottom]);
export const HORIZONTAL_DIRECTIONS = new Set<Direction>([Direction.Left, Direction.Right]);
export const NEGATIVE_DIRECTIONS = new Set<Direction>([Direction.Left, Direction.Top]);

export enum TrackingEvent {
  CollapsedPanel = `Collapsed Panel`,
  ExpandedPanel = `Expanded Panel`,
  ExtraActionClicked = `Extra Action Clicked`,
  Resize = `Resize`,
  Reset = `Reset Panel`,
  Reorder = `Reorder`,
}

export enum ResetPanelSource {
  DoubleClick = `Double Click`,
  SnapToDefault = `Snap to Default`,
}

export enum ExpandPanelSource {
  SwitchToFixedSize = `Switch to Fixed Size`,
}

export enum CollapsePanelSource {
  ResizedToEdge = `Resized to Edge`,
  ClickOutsideOverlay = `Click Outside Overlay`,
}

export enum OtherTogglePanelSource {
  Button = `Button`,
  KeyboardShortcut = `Keyboard Shortcut`,
}

export type TogglePanelSource = OtherTogglePanelSource | ExpandPanelSource | CollapsePanelSource;
